import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { IAppEntity } from "../../entities";
import { NFLookupTakeInAccounts } from "../../../components/Shared/NewForms/NFLookupTakeInAccounts";
import { CreateFixedAssetsTakeInAccountsDto } from "../../../dtos/documents/FixedAssetsTakeInAccounts/CreateFixedAssetsTakeInAccountsDto";
import FixedAssetsTakeInAccountsDetails from "../../../components/Pages/Documents/FixedAssetsTakeInAccounts/FixedAssetsTakeInAccountsDetails";
import FixedAssetsTakeInAccountsList from "../../../components/Pages/Documents/FixedAssetsTakeInAccounts/FixedAssetsTakeInAccountsList";
import { FixedAssetsTakeInAccountsService } from "../../../services/documents/FixedAssetsTakeInAccountsService";

export const FixedAssetsTakeInAccounts: IAppEntity = {
  entityType: "document",
  title: "Take In Accounts",
  pluralTitle: "TakeInAccounts",
  apiUrl: "FixedAssetsTakeInAccounts",
  apiEnum: ReferenceTypes.DocumentFixedAssetsTakeInAccount,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(FixedAssetsTakeInAccountsDetails, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(FixedAssetsTakeInAccountsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupTakeInAccounts, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () =>
    new FixedAssetsTakeInAccountsService("FixedAssetsTakeInAccounts"),
  getEmptyModel: () => {
    const model: CreateFixedAssetsTakeInAccountsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      fixedAssetsTakeInAccountConstructionObjectDto: [],
    };
    return model;
  },
};
